var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sw-js-blob-svg",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sw-gradient",
    x1: 0,
    x2: 1,
    y1: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop1",
    stopColor: "rgba(162.463, 162.487, 197.013, 1)",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop2",
    stopColor: "rgba(255, 255, 255, 1)",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#sw-gradient)",
    d: "M20.5,-36.1C25.8,-32.3,29.1,-25.5,31.6,-19C34.1,-12.4,35.9,-6.2,37.4,0.9C38.9,8,40.1,15.9,37.6,22.4C35,28.8,28.7,33.8,21.8,36.9C14.9,40.1,7.5,41.4,0.5,40.5C-6.4,39.5,-12.7,36.3,-19.1,32.8C-25.5,29.4,-31.9,25.7,-36.8,20.2C-41.8,14.7,-45.4,7.4,-44.3,0.6C-43.2,-6.1,-37.5,-12.2,-32.3,-17.3C-27.1,-22.4,-22.3,-26.4,-17,-30.2C-11.7,-34.1,-5.8,-37.8,0.8,-39.3C7.5,-40.8,15.1,-40,20.5,-36.1Z",
    width: "100%",
    height: "100%",
    transform: "translate(50 50)",
    strokeWidth: 0,
    style: {
      transition: "all 0.3s ease 0s"
    },
    stroke: "url(#sw-gradient)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.ab95a3283eee936d4988f857cc3d90f8.svg";
export { ForwardRef as ReactComponent };